/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface SiegeLieuSuiviActionEditDto
 */
export interface SiegeLieuSuiviActionEditDto {
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    idsiegeSocialLieuFormationSuiviAction?: number;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    idsiegeSocialLieuFormationSuivi?: number;
    /**
     * 
     * @type {Date}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    dateEcheance?: Date;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    idtypeSuiviAction?: number;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    idcollaborateurService?: number;
    /**
     * 
     * @type {Date}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    dateRealisation?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {FileUploadDto}
     * @memberof SiegeLieuSuiviActionEditDto
     */
    fichier?: FileUploadDto;
}

/**
 * Check if a given object implements the SiegeLieuSuiviActionEditDto interface.
 */
export function instanceOfSiegeLieuSuiviActionEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeLieuSuiviActionEditDtoFromJSON(json: any): SiegeLieuSuiviActionEditDto {
    return SiegeLieuSuiviActionEditDtoFromJSONTyped(json, false);
}

export function SiegeLieuSuiviActionEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeLieuSuiviActionEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeSocialLieuFormationSuiviAction': !exists(json, 'idsiegeSocialLieuFormationSuiviAction') ? undefined : json['idsiegeSocialLieuFormationSuiviAction'],
        'idsiegeSocialLieuFormationSuivi': !exists(json, 'idsiegeSocialLieuFormationSuivi') ? undefined : json['idsiegeSocialLieuFormationSuivi'],
        'dateEcheance': !exists(json, 'dateEcheance') ? undefined : (new Date(json['dateEcheance'])),
        'idtypeSuiviAction': !exists(json, 'idtypeSuiviAction') ? undefined : json['idtypeSuiviAction'],
        'idcollaborateurService': !exists(json, 'idcollaborateurService') ? undefined : json['idcollaborateurService'],
        'dateRealisation': !exists(json, 'dateRealisation') ? undefined : (json['dateRealisation'] === null ? null : new Date(json['dateRealisation'])),
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fichier': !exists(json, 'fichier') ? undefined : FileUploadDtoFromJSON(json['fichier']),
    };
}

export function SiegeLieuSuiviActionEditDtoToJSON(value?: SiegeLieuSuiviActionEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeSocialLieuFormationSuiviAction': value.idsiegeSocialLieuFormationSuiviAction,
        'idsiegeSocialLieuFormationSuivi': value.idsiegeSocialLieuFormationSuivi,
        'dateEcheance': value.dateEcheance === undefined ? undefined : (value.dateEcheance.toISOString()),
        'idtypeSuiviAction': value.idtypeSuiviAction,
        'idcollaborateurService': value.idcollaborateurService,
        'dateRealisation': value.dateRealisation === undefined ? undefined : (value.dateRealisation === null ? null : value.dateRealisation.toISOString()),
        'remarque': value.remarque,
        'idfichier': value.idfichier,
        'fichier': FileUploadDtoToJSON(value.fichier),
    };
}

